import { Sparkles, Church, Flower2, HeartHandshake } from "lucide-react";

const FEATURES = [
  { icon: Sparkles, title: "Modern Niche Halls", desc: "Elegant marble-finished vaults in a bright, contemporary setting" },
  { icon: Church, title: "Memorial Chapel", desc: "A quiet space for services, prayers, and remembrance" },
  { icon: Flower2, title: "Reflection Areas", desc: "Serene corners for families to gather and remember" },
  { icon: HeartHandshake, title: "Perpetual Care", desc: "Maintained with the same devotion as the entire Park" },
];

export default function Columbarium() {
  return (
    <section id="columbarium" className="bg-[#0C2340] py-20 sm:py-28 px-4 sm:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#C59B27]">Our Newest Project</p>
            <h2 data-testid="columbarium-heading" className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-white mt-4 leading-tight">
              In Aeternum Columbarium — a new place of eternal rest
            </h2>
            <p className="mt-6 text-base text-white/75 leading-relaxed">
              Rising within Davao Memorial Park, the In Aeternum Columbarium
              offers a modern, dignified home for cremated remains. Thoughtfully
              designed halls of niches give families a beautiful place to visit,
              remember, and celebrate life — for generations to come.
            </p>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6">
              {FEATURES.map((f) => (
                <div key={f.title} data-testid={`columbarium-feature-${f.title.toLowerCase().replace(/\s+/g, "-")}`} className="flex gap-3.5">
                  <span className="shrink-0 w-10 h-10 rounded-lg bg-[#C59B27]/15 flex items-center justify-center">
                    <f.icon className="w-5 h-5 text-[#C59B27]" />
                  </span>
                  <div>
                    <h3 className="text-white font-semibold text-sm">{f.title}</h3>
                    <p className="text-white/60 text-sm mt-1">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href="#inquire"
              data-testid="columbarium-inquire-btn"
              className="inline-block mt-10 bg-[#C59B27] hover:bg-[#b08b22] text-[#0C2340] font-semibold px-8 py-3.5 rounded-full transition-all duration-300 hover:-translate-y-0.5 shadow-lg shadow-[#C59B27]/20"
            >
              Reserve Your Niche — Inquire Now
            </a>
          </div>

          <div className="space-y-6">
            <img
              src="/images/columbarium-exterior.jpg"
              alt="In Aeternum Columbarium building at Davao Memorial Park"
              data-testid="columbarium-exterior-image"
              className="rounded-2xl w-full object-cover shadow-[0_12px_32px_rgba(0,0,0,0.35)]"
            />
            <img
              src="/images/columbarium-interior.jpg"
              alt="Elegant niche halls inside the In Aeternum Columbarium"
              data-testid="columbarium-interior-image"
              className="rounded-2xl w-full object-cover shadow-[0_12px_32px_rgba(0,0,0,0.35)]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
